import React, { useEffect, useState,useRef } from 'react';
import axios from 'axios';
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
  Select,
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx'
import EditQuickBillModal from './quickBillEditModal';
import { set } from 'lodash';
import { numberToWords } from '../utils/numberToWords';


const QuickBillData = () => {
  const {onOpen,isOpen,onClose}=useDisclosure()
  const cancelRef = useRef();
  const [isOpen1,setIsOpen]=useState(false)
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [editItemId, setEditItemId] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [printData,setPrintData]=useState([])
 

  const customerId = localStorage.getItem('customerId');

  const fetchData = async () => {
    const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getQuickBillDataByDateRange/${customerId}?startDate=${startDate}&endDate=${endDate}`);
    setData(response.data.quickBill);
    setFilteredData(response.data.quickBill);
  };
  const fetchEditData=async(id)=>{
    try {
      const response=await axios.get(`https://api.rcb.tdrsoftware.in/api/getQuickBillData/${customerId}/${id}`);
      setEditData(response.data.quickBill);
      setEditItemId(id);
      onOpen()
      
    } catch (error) {
      toast.error("No Bill found By this specific Id");
      
    }
  }
  const fetchData3 = async () => {
    try {
      const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getPrintData/${customerId}`);
      const rooms = response.data;
  
      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(`https://api.rcb.tdrsoftware.in/get-image/${room.image}`, {
              responseType: 'blob', // Assuming image is returned as a blob
            });
  
            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        })
      );
      console.log(updatedRooms, 'updatedRooms');
      setPrintData(updatedRooms);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    }
  const handlePayment = async (id) => {
    try {
      const response = await axios.put(`https://api.rcb.tdrsoftware.in/api/updatePayment/${customerId}/${id}`);
      alert(response.data.message);
      window.location.reload('/quickBillData');
    } catch (error) {
      toast.error(error);
    }
  };
  useEffect(() => {
    //fetchData();
    fetchData3()
   
  }, [customerId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter(order => {
      const orderDate = new Date(order.createdAt).getTime();
     

      if (!term ) {
        return true; // No filters applied, return all data
      }

      const matchesTerm = term ? (
        order.name.toLowerCase().includes(term.toLowerCase()) ||
        order.phoneNo.includes(term) // Include phone number in search
      ) : true; // If no term, treat it as true

      

      return (matchesTerm || !term); // If no term, skip term filtering, only use date range
    });

    setFilteredData(filtered);
};
const handleEdit = (itemId) => {
  setEditItemId(itemId);
  fetchEditData()
  onOpen();
};
useEffect(()=>{
  if(startDate && endDate){
  fetchData()
  } 
},[startDate,endDate])


const handlePrint = (order) => {
  let total=numberToWords(order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.05+ order.wineItem.reduce((acc, item) => acc + item.price, 0)+(order.foodItem.reduce((acc, item) => acc + item.price, 0)): order.wineItem.reduce((acc, item) => acc + item.price, 0)+(order.foodItem.reduce((acc, item) => acc + item.price, 0)))
  const content = `
    <html>
      <head>
        <style>
          body { font-family: Arial, sans-serif; width: 3in; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
          th, td { border-bottom: 1px dashed black; text-align: left; padding: 4px; font-size: 12px; }
          th { background-color: #f2f2f2; }
          h4, h5 { text-align: center; margin: 4px 0; font-size: 12px; }
          .center { text-align: center; margin-bottom: 10px; }
          .footer { text-align: right; margin-top: 20px; font-size: 12px; }
                 .left {
 
  font-size: 10px;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px dashed black;
}
  .Grid{
      display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
     place-items:center
  }
          .summary {
  margin-top: 10px;
  font-size: 12px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
  border-bottom: 1px dashed black;
  padding:8px
}
          img { width: 90px; height: 60px; border-radius: 8px; display: block; margin: 0 auto; }
        </style>
      </head>
      <body>
        ${printData.map((item) => `
          <div class="center">
            <h4>Cash Memo</h4>
            <img src="${item.imageUrl}" alt="Logo" />
            <h4><b>${item.name}</b></h4>
            <h5>${item.adress}</h5>
            <h5>Phone: ${item.phoneNo}</h5>
            <h5>${item.website}</h5>
            ${item.gstNo ? `<h5>GST No: ${item.gstNo}</h5>` : ''}
            ${item.fssaiNo ? `<h5>FSSAI No: ${item.fssaiNo}</h5>` : ''}
          </div>
        `).join('')}
        <div class="Grid">
        <h4>Table:${order.tableNo}</h4>
        <h4>Bill:${order.billNo}</h4>
        
        
        
        </div>
        <div>
        <h4>Date:${new Date(order.createdAt).toLocaleString('en-GB')}</h4>
        </div>
        
        ${order.wineItem.length > 0 ? `
          <h4 class="center"># Wine Items #</h4>
          <table>
            <thead>
              <tr>
                <th>Item Description</th>
                <th>Rate</th>
                <th>Qty</th>
                
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              ${order.wineItem.map(item => `
                <tr>
                  <td>${item.name}</td>
                  <td>${(item.price / item.quantity).toFixed(2)}</td>
                  <td>${item.quantity}</td>
                  
                  <td>${item.price}</td>
                </tr>
              `).join('')}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="footer">Gross Total: ${order.wineItem.reduce((acc, item) => acc + item.price, 0)}</td>
              </tr>
              <tr>
                <td colspan="5" class="footer">Drinks Total: ${order.wineItem.reduce((acc, item) => acc + item.price, 0)}</td>
              </tr>
            </tfoot>
          </table>
        ` : ''}

        <h4 class="center"># Food Items #</h4>
        <table>
          <thead>
            <tr>
              <th>Item Description</th>
              <th>Rate</th>
              <th>Qty</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            ${order.foodItem.map(item => `
              <tr>
                <td>${item.name}</td>
                <td>${(item.price / item.quantity).toFixed(2)}</td>
                <td>${item.quantity}</td>
                <td>${item.price}</td>
              </tr>
            `).join('')}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="footer">Gross Total: ${order.foodItem.reduce((acc, item) => acc + item.price, 0)}</td>
            </tr>
            <tr>
              <td colspan="4" class="footer">Add @ 2.5% CGST on Gross: ${order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.025 : 0 }</td>
            </tr>
            <tr>
              <td colspan="4" class="footer">Add @ 2.5% SGST on Gross: ${order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.025 : 0 }</td>
            </tr>
             <tr>
              <td colspan="4" class="footer">5% Total Gst: ${order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.05 : 0 }</td>
            </tr>
            <tr>
              <td colspan="4" class="footer">Food Total: ${order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.05+order.foodItem.reduce((acc, item) => acc + item.price, 0) : order.foodItem.reduce((acc, item) => acc + item.price, 0) }</td>
            </tr>
          </tfoot>
        </table>
        <div class="summary">
        <h4 class="center">Net Gross Total Amount ${order.wineItem.reduce((acc, item) => acc + item.price, 0)+(order.foodItem.reduce((acc, item) => acc + item.price, 0))}</h4>
        <h4 class="center">5% GST Total ${order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.05 : 0 }</h4>
        <h4 class="center">Total Amount ${order.gst === false ? (order.foodItem.reduce((acc, item) => acc + item.price, 0))*0.05+ order.wineItem.reduce((acc, item) => acc + item.price, 0)+(order.foodItem.reduce((acc, item) => acc + item.price, 0)): order.wineItem.reduce((acc, item) => acc + item.price, 0)+(order.foodItem.reduce((acc, item) => acc + item.price, 0)) }</h4>
          

        </div>
        <div class='left'>
        <h4 >Total Amount (INR in words): ${total}</h4>
        </div>

        <div class="footer">
        <h5>Thank you</h5>
        <h5>Visit Again</h5>
        </div>

        <script>
          window.onload = () => window.print();
        </script>
      </body>
    </html>
  `;

  const printWindow = window.open('', '', 'height=600,width=800');
  printWindow.document.open();
  printWindow.document.write(content);
  printWindow.document.close();
};

  
  const exportToExcel = () => {
    // Prepare data for export by flattening foodItem and wineItem arrays
    const cleanedData = filteredData.map((order) => {
      // Concatenate all food items with NameXQuantity format
      const foodItemsCombined = order.foodItem
        .map(foodItem => `${foodItem.name}X${foodItem.quantity}`)
        .join(', '); // Join all items into a single string
  
      // Concatenate all wine items with NameXQuantity format
      const wineItemsCombined = order.wineItem
        .map(wineItem => `${wineItem.name}X${wineItem.quantity}`)
        .join(', ');
  
      return {
        Name: order.name,
        PhoneNo: order.phoneNo,
        FoodItems: foodItemsCombined, // Combined food items in one cell
        WineItems: wineItemsCombined, // Combined wine items in one cell
        TotalBill: order.totalBilling,
        TableNo: order.tableNo,
        
        CreatedAt: new Date(order.createdAt).toLocaleString('en-GB')
      };
    });
  
    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
  
    // Add borders and other styling (if needed)
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'QuickBillData');
  
    // Write the workbook to an Excel file
    XLSX.writeFile(workbook, `${startDate}-${endDate}-BillData.xlsx`);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rcb.tdrsoftware.in/api/deleteQuickBill/${customerId}/${deleteItemId}`
      );
      toast.success(response.data.message);
      setIsOpen(false);
      fetchData();
    } catch (error) {
      toast.error(error.message);
    }
  };
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  

  return (
    <Box>
      <Box mb={4} display="flex" justifyContent="center" alignItems='center' gap={2} mt={2}>
        <Input
          w='40%'
          type="text"
          placeholder="Search by Name or Phone"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <Input
          w='20%'
          type="date"
          placeholder="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          mr={2}
        />
        <Input
          w='20%'
          type="date"
          placeholder="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          mr={2}
        />
       
      </Box>
      <Box display='flex' justifyContent='center' alignItems='center' gap={2}>
      <Button colorScheme="blue" onClick={exportToExcel} p={2} mb={5}>
       Export to Excel File
      </Button>
      </Box>
      
      <EditQuickBillModal data={editData} onOpen={onOpen} onClose={onClose} isOpen={isOpen} customerId={customerId} setSelectId={setEditItemId} id={editItemId} />
      <TableContainer width='full'>
        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Quick Bill Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Food Item</Th>
              <Th>Wine Item</Th>
              <Th>Name</Th>
              <Th>Phone No</Th>
              <Th>Bill No</Th>
              <Th>Table No</Th>
              <Th>Server Name</Th>
              <Th>Total Bill</Th>
              
    <Th>Discount</Th>
    <Th>Discount%</Th>
    <Th>Remark</Th>
    <Th>Cash</Th>
    <Th>Mode</Th>
    <Th>Online</Th>
    <Th>Due</Th>

              
              <Th>Created At</Th>
             <Th>Edit</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((order, index) => (
              <Tr key={index}>
                <Td><Table size='xsm' variant='striped' colorScheme='orange'>
                    <Thead>
                        <Tr>
                            <Td>Name</Td>
                            <Td>Quantity</Td>
                            <Td>Price</Td>
                        </Tr>
                    </Thead>
                    <Tbody>
                        
                            {order.foodItem.map((item, index) => (
                                <Tr>
                                    <Td>{item.name}</Td>
                                    <Td>{item.quantity}</Td>
                                    <Td>{item.price}</Td>
                                    </Tr >
                                
                            ))}
                        
                    </Tbody>
                </Table></Td>
                <Td>
                <Table size='xsm' variant='striped' colorScheme='yellow'>
                    <Thead>
                        <Tr>
                            <Td>Name</Td>
                            <Td>Quantity</Td>
                            <Td>Price</Td>
                        </Tr>
                    </Thead>
                    <Tbody>
                        
                            {order.wineItem.map((item, index) => (
                                <Tr>
                                    <Td>{item.name}</Td>
                                    <Td>{item.quantity}</Td>
                                    <Td>{item.price}</Td>
                                    </Tr>
                                
                            ))}
                        
                    </Tbody>
                </Table>
                </Td>
                <Td>{order.name}</Td>
                <Td>{order.phoneNo}</Td>
                <Td>{order.billNo}</Td>
                <Td>{order.tableNo}</Td>
                <Td>{order.server}</Td>
                <Td>{order.totalBilling}</Td>
                <Td>{order.discount}</Td>
                <Td>{order.discountPercentage}</Td>
                <Td>{order.remark}</Td>
                <Td>{order.cash}</Td>
                <Td>{order.mode}</Td>
                <Td>{order.online}</Td>
                <Td>{order.due}</Td>

                {/* <Td>{order.status ? "Due" : "Paid"}</Td>
                <Td onClick={()=>handlePayment(order._id)}> <Button colorScheme='green'  onClick={()=>handlePayment(order._id)}>Change</Button></Td> */}
                <Td>{new Date(order.createdAt).toLocaleString('en-GB')}</Td>
                <Td>
                  <Button colorScheme="blue" size="sm" onClick={() => handlePrint(order)}>Print</Button>
                </Td>
                <Td ><Button colorScheme='green' onClick={()=>fetchEditData(order._id)}>Edit</Button></Td>
                <Td ><Button colorScheme='red' onClick={()=>openModal(order._id)}>Delete</Button></Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default QuickBillData;
